import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";

const TODOS_HABILITADOS = {
    modGastos: true,
    modExpensas: true,
    modComunicados: true,
    modReclamos: true,
    modReservas: true,
    modInventario: true,
    modPaquetes: true,
    modVisitas: true,
    modFondos: true,
    modPlanesPago: true,
    modSentenciaJudicial: true,
    modCargoPeriodoUF: true,
    modPagos: true,
};

export const ModulosContext = createContext();

export const ModulosProvider = ({ children }) => {
    const { administracionId } = useAuth();
    const [modulos, setModulos] = useState(TODOS_HABILITADOS);
    const [loadingModulos, setLoadingModulos] = useState(true);

    useEffect(() => {
        if (!administracionId) return;
        const HOST_API = process.env.REACT_APP_URL;
        setLoadingModulos(true);
        axios.get(`${HOST_API}api/administracionModulos/GetModulos`, { params: { administracionId } })
            .then(({ data }) => setModulos({ ...TODOS_HABILITADOS, ...data }))
            .catch(() => setModulos(TODOS_HABILITADOS))
            .finally(() => setLoadingModulos(false));
    }, [administracionId]);

    return (
        <ModulosContext.Provider value={{ modulos, loadingModulos }}>
            {children}
        </ModulosContext.Provider>
    );
};

export const useModulos = () => useContext(ModulosContext);
